import type { IconData } from '@stacksjs/iconify-core'

export const arrowThickToRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M176 56v120H16v160h160v120h38.623l200-199.8L214.635 56Zm32 361.384V304H48v-96h160V94.639l161.373 161.535ZM463.998 56h32v400h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowThickToRight
